// assets
import {
    LoginOutlined,
    ProfileOutlined,
    MessageFilled,
    CustomerServiceFilled,

} from '@ant-design/icons';

// icons
const icons = {
    LoginOutlined,
    ProfileOutlined,
    MessageFilled,
    CustomerServiceFilled,

};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const support = {
    id: 'support',
    title: 'Support',
    type: 'group',
   app: 'ipms',
    children: [
        {
            id: 'feedback',
            title: 'Feedback',
            type: 'item',
            url: '/comments',
            icon: icons.CustomerServiceFilled,
            breadcrumbs: false
        },
        {
            id: 'about',
            title: 'About',
            type: 'item',
            url: '/about',
            icon: icons.MessageFilled,
            breadcrumbs: false
        },
      

    ]
};

export default support;
